import React, { Component } from 'react'
import { reduxForm } from 'redux-form'

import GuestFormDefault from './layouts/GuestFormDefault'

import { countries } from '../../../utilities/content/supportedCountries'
import { syncRevinateGuestFields } from '../../../utilities/revinate/syncRevinateFromForm'
import {
	isValidEmailRegex,
	isNotSpecialCharacterRegex,
	isLatinRegexWithSpaces,
} from '../../../utilities/content/validateFormFields'

import _ from 'lodash'
import yn from 'yn'

const validate = (values, props) => {
	const {
		configData,
		isGuestPrefixRequired,
		formData
	} = props

	const hotelLabels = _.get(configData, 'hotel.labels[0]', [])
	let isCountryWithStates = false

	const errors = {}

	if (
		countries &&
		!_.isEmpty(formData) &&
		_.get(formData, 'guestForm.values.country')
	) {
		const currentCountryData = countries.filter(function(country) {
			return country.alpha2Code === formData.guestForm.values.country
		})

		if (
			currentCountryData &&
			currentCountryData[0] &&
			currentCountryData[0].states &&
			currentCountryData[0].states.length > 0
		) {
			isCountryWithStates = true
		}
	}

	if (isGuestPrefixRequired && !values.prefix) {
		errors.prefix = hotelLabels.guestFormPrefixError ? hotelLabels.guestFormPrefixError : 'Prefix is required'
	}

	if (!values.firstName) {
		errors.firstName = hotelLabels.guestFormFirstNameError ? hotelLabels.guestFormFirstNameError : 'First name is required'
	} else if (values.firstName.length < 2) {
		errors.firstName = hotelLabels.guestFormMinLengthError ? hotelLabels.guestFormMinLengthError : 'Minimum 2 characters required'
	} else if (!isNotSpecialCharacterRegex(values.firstName)) {
		errors.firstName = hotelLabels.guestFormSpecialCharacterError ? hotelLabels.guestFormSpecialCharacterError : 'Special characters are not permitted'
	} else if (
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_LATIN_CHARACTERS_ONLY) &&
		!isLatinRegexWithSpaces(values.firstName)
	) {
		errors.firstName = hotelLabels.guestFormLatinCharacterError ? hotelLabels.guestFormLatinCharacterError : 'Latin characters only'
	}

	if (!values.lastName) {
		errors.lastName = hotelLabels.guestFormLastNameError ? hotelLabels.guestFormLastNameError : 'Last name is required'
	} else if (values.lastName.length < 2) {
		errors.lastName = hotelLabels.guestFormMinLengthError ? hotelLabels.guestFormMinLengthError : 'Minimum 2 characters required'
	} else if (!isNotSpecialCharacterRegex(values.lastName)) {
		errors.lastName = hotelLabels.guestFormSpecialCharacterError ? hotelLabels.guestFormSpecialCharacterError : 'Special characters are not permitted'
	} else if (
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_LATIN_CHARACTERS_ONLY) &&
		!isLatinRegexWithSpaces(values.lastName)
	) {
		errors.lastName = hotelLabels.guestFormLatinCharacterError ? hotelLabels.guestFormLatinCharacterError : 'Latin characters only'
	}

	if (!values.email) {
		errors.email = hotelLabels.guestFormEmailError ? hotelLabels.guestFormEmailError : 'Email is required'
	} else if (!isValidEmailRegex(values.email)) {
		errors.email = hotelLabels.guestFormEmailInvalidError ? hotelLabels.guestFormEmailInvalidError : 'Invalid email address'

	}

	if (!values.phone) {
		errors.phone = hotelLabels.guestFormPhoneError ? hotelLabels.guestFormPhoneError : 'Phone is required'
	}

	if (
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_ADDRESS_PRIMARY) &&
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_ADDRESS_REQUIRED)
	) {
		const maxFieldLength = process.env.REACT_APP_COMPONENT_GUEST_FORM_ADDRESS_MAX_LENGTH
			? parseInt(process.env.REACT_APP_COMPONENT_GUEST_FORM_ADDRESS_MAX_LENGTH, 10)
			: null
		if (!values.address1) {
			errors.address1 = hotelLabels.guestFormAddressError ? hotelLabels.guestFormAddressError : 'Address is required'
		} else if (maxFieldLength && values.address1.length > maxFieldLength) {
			errors.address1 = hotelLabels.guestFormAddressMaxLengthError || `Address must be ${maxFieldLength} characters or less`
		}
	}

	if (
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_COUNTRY) &&
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_COUNTRY_REQUIRED) &&
		(!values.country || values.country === '0')
	) {
		errors.country = hotelLabels.guestFormCountryError ? hotelLabels.guestFormCountryError : 'Country is required'
	}

	if (
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_CITY_TOWN) &&
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_CITY_TOWN_REQUIRED) &&
		!values.city
	) {
		errors.city = hotelLabels.guestFormCityTownError ? hotelLabels.guestFormCityTownError : 'City or town is required'
	}

	if (
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_STATE_PROVINCE) &&
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_STATE_PROVINCE_REQUIRED) &&
		isCountryWithStates &&
		!values.stateProv
	) {
		errors.stateProv = hotelLabels.guestFormStateProvError ? hotelLabels.guestFormStateProvError : 'State or province is required'
	} else if (
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_STATE_PROVINCE) &&
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_STATE_PROVINCE_REQUIRED) &&
		isCountryWithStates &&
		values.stateProv === '0'
	) {
		errors.stateProv = hotelLabels.guestFormStateProvError ? hotelLabels.guestFormStateProvError : 'State or province is required'
	}

	return errors
}

class GuestForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			requestsExpanded: false
		}
	}

	handleSpecialRequests = () => {
		this.setState({
			requestsExpanded: !this.state.requestsExpanded
		})
	}

	render() {
		const {
			configData,
			formData,
			isGuestPrefixRequired,
		} = this.props

		const hotelComponents = configData.hotel.options.components
		const hotelLabels = configData.hotel.labels[0]
		const coreLinks = configData.core.options.links

		let stateProvinceData = null

		// Check current set country for applicable state/provinces
		if (
			countries &&
			!_.isEmpty(formData) &&
			_.get(formData, 'guestForm.values.country')
		) {
			const currentCountryData = countries.filter(function(country) {
							return country.alpha2Code === formData.guestForm.values.country
						})

			if (
				currentCountryData &&
				currentCountryData[0] &&
				currentCountryData[0].states &&
				currentCountryData[0].states.length > 0
			) {
				stateProvinceData = currentCountryData[0].states
			}
		}

		return (
			<GuestFormDefault
				privacyPolicyLink={coreLinks.brandPrivacyPolicyLink && coreLinks.brandPrivacyPolicyLink}
				formPrefixes={hotelComponents.formPrefixes && hotelComponents.formPrefixes}
				hotelLabels={hotelLabels}
				isGuestPrefixRequired={isGuestPrefixRequired}
				requestsExpanded={this.state.requestsExpanded}
				requestsEvent={() => this.handleSpecialRequests()}
				stateProvinceData={stateProvinceData}
			/>
		)
	}
}

export default reduxForm({
	validate,
	destroyOnUnmount: true,
	keepDirtyOnReinitialize: false,
	onChange: (values, dispatch, props, previousValues) =>
		syncRevinateGuestFields(values, previousValues),
})(GuestForm)


// WEBPACK FOOTER //
// ./src/components/forms/guestForm/GuestForm.js